var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 464,
    height: 142,
    viewBox: "0 0 464 142",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.1 109.6C245.8 109.6 241.5 105.3 241.5 100V70.8V35.4C241.4 15.9 225.6 0 206 0H194.5V31.9H201.1C206.4 31.9 210.7 36.2 210.7 41.5V70.7V106C210.7 125.6 226.6 141.4 246.1 141.4H257.6V109.5H251.1V109.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3 109.6C309 109.6 304.7 105.3 304.7 100V70.8V35.4C304.7 15.8 288.8 0 269.3 0H257.8V31.9H264.4C269.7 31.9 274 36.2 274 41.5V70.7V106C274 125.6 289.9 141.4 309.4 141.4H320.9V109.5H314.3V109.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6 35.6C344.5 35.6 320.9 59.2 320.9 88.3C320.9 117.4 344.5 141 373.6 141C402.7 141 426.3 117.4 426.3 88.3C426.3 59.2 402.7 35.6 373.6 35.6ZM373.6 113.1C359.9 113.1 348.8 102 348.8 88.3C348.8 74.6 359.9 63.5 373.6 63.5C387.3 63.5 398.4 74.6 398.4 88.3C398.4 102 387.3 113.1 373.6 113.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 126.2C464 134.5 457.2 141.3 448.9 141.3C440.6 141.3 433.8 134.5 433.8 126.2C433.8 117.9 440.6 111.1 448.9 111.1C457.3 111.1 464 117.8 464 126.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.6 0V7.7V104.3H463.2V7.7V0H435.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 123.4L13.4 101.6C25.1 109.4 38 113.3 48.6 113.3C54.8 113.3 59.9 111.4 59.9 107.4C59.9 103.4 52 101.5 41.2 98.7C21 93.3 4.9 86.7 4.9 65.7C4.9 43.9 22.3 31.8 46 31.8C61 31.8 76.5 36.2 88.2 43.7L75.9 66.4C65.3 60.6 53.8 57 45.6 57C40.1 57 37.3 59.1 37.3 62.3C37.3 66.3 43.2 68.2 54 71.4C74.3 77.3 90.4 84.1 90.4 104.3C90.4 126.8 73.5 138.6 48.6 138.6C31.2 138.6 14.2 133.7 0 123.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.2 88.2C200.2 59.1 176.6 35.5 147.5 35.5C118.4 35.5 94.8 59.1 94.8 88.2C94.8 117.9 118.5 140.9 148.5 140.9C172.7 140.9 188 129.4 195.7 115.6L165.5 106.9C161.3 109.7 156.8 111.8 148.9 111.8C136.5 111.8 127.5 105 125 95.3H200.2V88.7V88.2ZM147.5 64.6C158.2 64.6 167.2 71.6 170.1 81.3H124.9C127.9 71.6 136.9 64.6 147.5 64.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 464,
    height: 141.6,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.5bebd49a3aa2613bf41062ab45d0c264.svg";
export { ForwardRef as ReactComponent };